// The card — the account menu's body. The person is a plate (drawn by the
// menu's head, ProfilePopover.tsx) and his figures stand in the same plate,
// under a hairline: who I am and what I have read as one thing. Under it only
// the account's own things, a row each: Settings, What's new (the release
// notes the app shows once per release, to read again — the operator,
// 2026-10-18: "a door to What's New from the account menu: yes"), the way back
// into a locked account, and the two pages that are not there yet. Where the
// product's pages are (Portfolio, Rewards) is the header's business, not this
// menu's.

import {
  CaretRightIcon,
  GearSixIcon,
  type Icon,
  ShieldCheckIcon,
  SparkleIcon,
} from '@phosphor-icons/react'
import { type AccountBodyProps, FigureCells, SoonRows } from './AccountParts'
import styles from './profile.module.css'

export function AccountCard({
  figures,
  restorable,
  onSettings,
  onRestore,
  onWhatsNew,
}: AccountBodyProps) {
  return (
    <div className={styles.links}>
      <FigureCells figures={figures} />
      <div className={styles.group}>
        <Item icon={GearSixIcon} label="Settings" onClick={onSettings} />
        {onWhatsNew ? <Item icon={SparkleIcon} label="What's new" onClick={onWhatsNew} /> : null}
        {restorable ? (
          <Item icon={ShieldCheckIcon} label="Restore account" onClick={onRestore} />
        ) : null}
        <SoonRows restorable={restorable} />
      </div>
    </div>
  )
}

function Item({ icon: I, label, onClick }: { icon: Icon; label: string; onClick: () => void }) {
  return (
    <button type="button" className={styles.item} onClick={onClick}>
      <I size={18} weight="bold" className={styles.itemIcon} aria-hidden="true" />
      <span className={styles.itemLabel}>{label}</span>
      <CaretRightIcon size={12} weight="bold" className={styles.itemChevron} aria-hidden="true" />
    </button>
  )
}
